import React, { Component } from 'react';
import { URLImgFront } from '../../../config/URLDB';

class Seccion03CooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeButton: null
        };
    }

    getActiveButton = (isActive) => {
        return {
            outline: 'none',
            display: 'block',
            margin: 'auto',
            transition: 'transform 0.15s ease',
            transform: isActive ? 'scale(0.96)' : 'scale(1)',
            backgroundColor: 'transparent',
            border: 0
        };
    }

    scrollToStar = () => {
        const target = document.getElementById("seccion01");
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    render() {
        window.scrollTo(0, 0);
        return (
            <React.Fragment>
                <section className="planestimulos-contenedor" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/FondoBlanco.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                    <div className="planestimulos-fechas">
                        <div>
                            <img src={`${URLImgFront}/assets/EstrategiasComerciales/FechasImportantes.svg`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp"/>
                        </div>

                        <div>
                            <img src={`${URLImgFront}/assets/EstrategiasComerciales/Fechas.svg`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp"/>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Seccion03CooperaGanaMas;